<template>
<div class="page-container">
    <div v-if="game" class="row no-gutters justify-content-center text-center">
        <div class="col-12">
            <div class="display-block">
                <div class="row no-gutters mb-4">
                    <div class="col-12 text-center">
                        <div v-if="!game.isComplete" class="main-header">
                            {{ fromWei(game.reward) }} NAS was Hidden -- Find it by Clicking a Point on the Grid!
                        </div> 
                        <div v-else-if="game.isComplete && !game.winner" class="main-header">
                            This game is over, but no one guessed {{ game.rewardPoint }}! Too bad, keep hunting pirates!
                        </div>  
                        <div v-else-if="game.isComplete && game.winner" class="main-header">
                            <div class="mb-2">
                                WOW! A pirate found the {{ fromWei(game.reward) }} NAS treasure!
                            </div>
                            <div class="d-none d-sm-block">
                                {{ game.winner }}
                            </div>
                            <div class="d-block d-sm-none">
                                {{ game.winner.substr(game.winner.length-4, 4) }}
                            </div>
                        </div>                         
                    </div>
                </div>  

                <div class="row mb-2">
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            Owner
                        </header>
                        <div>
                            {{ game.owner.substr(game.owner.length-4, 4) }}
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            Grid Size
                        </header>
                        <div>
                            {{ game.gridSize }}
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            Status
                        </header>
                        <div>
                            {{ game.isComplete ? 'Closed' : 'Open' }}
                        </div>
                    </div>

                    <div class="col-item col-4 col-sm-2">
                        <header>
                            Guesses
                        </header>
                        <div>
                            {{ game.guessCounter }} / {{ game.maxGuesses }}
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            Price to Play
                        </header>
                        <div>
                            {{ game.price }} NAS
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            Earnings
                        </header>
                        <div>
                            {{ fromWei(game.earnings) }} NAS
                        </div>
                    </div>
                </div>      
            </div>
        </div>
    </div>

    <div v-if="game" class="row no-gutters justify-content-center text-center mb-3">
        <div class="col-12">
            <div class="display-block pt-4 guess-block">  
                <div class="action-container mb-3">
                    <button @click="showLog = true" v-if="!showLog && !pendingTransaction" class="btn btn-primary">Show Guess Log</button>
                    <button @click="showLog = false" v-else-if="showLog && !pendingTransaction" class="btn btn-primary">Hide Guess Log</button>
                    <button v-else disabled class="btn btn-secondary">Please wait ...</button>
                </div>       
                <div v-if="showLog" class="guesslog-container mb-3">
                    <div v-for="(guess, index) in game.guesses" :key="index" class="guess-item mb-2">
                        {{ guess.owner.substr(guess.owner.length-4, 4) }} -  
                        guessed <strong>{{ index }}</strong>
                        on {{ formatDate(guess.guessedOn) }} 
                    </div>
                </div>            
            </div>
        </div>     
    </div>

    <div v-if="game" class="row no-gutters justify-content-center">
        <div v-for="(item, index) in game.gridSize" :key="index" class="col-6 col-sm-4 col-md-3 col-lg-2">
            <div v-if="!game.guesses[index+1]" @click="playGame(game, item, game.price)" :style="{ background: getHex() }" class="grid-item">                
                <div class="number-item">
                    {{ item }}
                </div>
            </div>
            <div v-else :class="{ winner: game.winner && item == game.rewardPoint }" class="grid-item guessed">                
                <div class="number-item">
                    {{ item }}
                </div>
                <div class="grid-item-info">
                    <span v-if="game.winner && item == game.rewardPoint">
                        The winner is {{ game.guesses[index+1].owner.substr(game.guesses[index+1].owner.length-4, 4) }}
                    </span>
                    <span v-else>
                        Guessed by: {{ game.guesses[index+1].owner.substr(game.guesses[index+1].owner.length-4, 4) }}
                    </span>
                </div>
            </div>
        </div>

    </div>

    <div v-if="!game" class="row no-gutters justify-content-center">
        <div class="col-md-12 text-center">
            <div class="generic-container">
                Hmm ... we're looking for your game, but can't find it yet.
            </div>
        </div>
    </div>

</div>

</template>

<script>
import { mapGetters } from "vuex";
import Card from "../components/Card";
import mockData from "../util/constants/mockData";
import * as newCardLogic from "../util/newCardLogic";
import TheBanner from "../components/layout/TheBanner";
import { contractAddress, nebPay, neb } from "../util/nebulas";

export default {
    name: "Block",
    computed: {
        ...mapGetters({
            game: 'getGame',
            games: 'getGames',
            pendingTransaction: 'getPendingTransaction'
        }),
        randomNumber () {
            return Math.floor(Math.random() * 10);
        }
    },
    created () {

        const id = this.$route.params.id;

        if (this.games.length > 0) {
            
            this.$store.commit('setGame', { id });

        } else {

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'setGames') {
                    this.$store.commit('setGame', { id });
                }
            });
            
        }

    },
    data() {
        return {
            showLog: false
        };
    },
    methods: {
        openModal () {
            this.$root.$emit('bv::show::modal','modal-grid');
        },

        getHex () {
            
            const colorSchme = {
                0: 0,
                1: 60,
                2: 120,
                3: 180,
                4: 240,
                5: 300,
                6: 0,
                7: 180,
                8: 240,
                9: 300, 
            };

            const h = colorSchme[this.randomNumber];
            const s = Math.floor(Math.random() * 100);
            const l = Math.floor(Math.random() * 100);
            return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
            
        },

        formatDate (date) {
            return this.$moment(new Date(date)).format('MM/DD/YYYY');
        },

        goToRoute (name) {
            this.$router.push(name);
        },
        
        fromWei (value) {
            return neb.fromBasic(value, "nas").toNumber();
        },
        
        playGame (game, gridId, price) {

            if (this.pendingTransaction) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please wait for the pending transaction to complete!'
                });

                return;
            }

            if (game.isComplete) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'This game is over!'
                });

                return;
            }

            const payload = { gameId: game.id, gridId, price };

            this.$store.commit('updatePendingTransaction', { status: true });
            this.$store.dispatch('playGame', payload).then((response) => {

                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Success!",
                        text: 'Your guess was submitted, please see results below!'
                    });

                } else if (response.message == 'error') {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error with your transaction'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was a problem loading your data, please refresh'
                    });

                }

                this.$store.commit('updatePendingTransaction', { status: false });

            });

        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/app.less";

.generic-container {
    padding: 40px;
    background: #3C3F44;
}

.page-container {
    padding: 20px;
    color: #fff;

    .display-block {
        background: #3c3f44;
        padding-bottom: 5px;

        .main-header {
            padding: 25px;
            font-size: 24px;
            margin-bottom: 10px;
            border-bottom: 3px solid #222532;
        }

        header {
            color: #96999C; 
        }

        .col-item {
            margin-bottom: 20px;
        }

        &.guess-block {
            border-top: 3px solid #222532;
        }
    }

    .grid-item {
        font-family: 'Gloria Hallelujah', cursive;
        font-size: 24px;
        position: relative;
        border: 2px solid #212432;
        background: #3c3f44;
        text-align: center;
        cursor: pointer;
        color: #ccc;
        padding: 100px 30px;   
        height: 225px;

        &:hover {
            color: #3c3f44;
            background: #efefef;
        }

        &.guessed {
            cursor: default;
            color: #efefef;
            background-color: darkgray;
            background-image: url(/static/grunge-x.png);
            background-size: auto 100%;
            background-repeat: no-repeat;
            background-position: center center;

            .number-item {
                color: #000;
            }
        }

        &.winner {
            background: #83A485;
        }

        .grid-item-info {
            font-size: 13px;
        }

        .number-item {
            border-radius: 50%;
            padding: 7px;
            background: #efefef;
            position: absolute;
            top: 10px; left: 10px;
            height: 50px;
            width: 50px;
        }
    }

}


// Tablet device
@media only screen and (max-width: 768px) {
    body {}
}

// Phone device
@media only screen and (max-width: 480px) {
     body {}
}
</style>



// WEBPACK FOOTER //
// src/views/Game.vue